/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Out_Of_Sync_HintInputs */



/**
* | output |
* | --- |
* | "Results changed after they were sent to vekn.net. Only a VEKN admin can correct them there." |
*
* @param {Vekn_Out_Of_Sync_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_out_of_sync_hint = /** @type {((inputs?: Vekn_Out_Of_Sync_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Out_Of_Sync_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les résultats ont changé après leur envoi à vekn.net. Seul un admin VEKN peut les corriger là-bas.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los resultados cambiaron después de enviarse a vekn.net. Solo un admin de la VEKN puede corregirlos allí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os resultados mudaram depois de enviados à vekn.net. Só um admin da VEKN pode corrigi-los lá.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I risultati sono cambiati dopo l'invio a vekn.net. Solo un admin VEKN può correggerli lì.")
	return /** @type {LocalizedString} */ ("Results changed after they were sent to vekn.net. Only a VEKN admin can correct them there.")
});